import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import EngineeringIcon from "@mui/icons-material/Engineering";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { motion, AnimatePresence } from "framer-motion";

const steps = [
  {
    Icon: DirectionsCarIcon,
    title: "Free Pick-Up",
    description: "We collect your car from your location at no extra cost.",
  },
  {
    Icon: BuildCircleIcon,
    title: "Detailed Inspection",
    description: "Our experts conduct a thorough check to identify any issues.",
  },
  {
    Icon: EngineeringIcon,
    title: "Get Serviced",
    description: "Your car receives top-quality service from expert mechanics.",
  },
  {
    Icon: LocalShippingIcon,
    title: "Same-Day Delivery",
    description: "Enjoy the convenience of returning your car on the same day.",
  },
];

const WorkProcessMobileView = () => {
  const [expandedStep, setExpandedStep] = useState(null);

  const toggleExpansion = (index) => {
    setExpandedStep(expandedStep === index ? null : index);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        px: { xs: 2, md: 6 },
        py: 6,
        background: "linear-gradient(to bottom, #fff 0%, #f9f9f9 100%)",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h4"
        sx={{ fontWeight: "bold", mb: 4, color: "#222" }}
      >
        🚗 Our Work Process
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
          width: "100%",
        }}
      >
        {steps.map((step, index) => (
          <motion.div
            key={index}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Card
              elevation={4}
              sx={{
                width: { xs: "90%", md: "450px" },
                borderRadius: "12px",
                backgroundColor: "#fff",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                transition: "0.3s",
                overflow: "hidden",
                position: "relative",
              }}
            >
              {/* Step number */}
              <Box
                sx={{
                  position: "absolute",
                  top: 12,
                  left: 12,
                  width: 26,
                  height: 26,
                  borderRadius: "50%",
                  backgroundColor: "orangered",
                  color: "#fff",
                  fontSize: "13px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                }}
              >
                {index + 1}
              </Box>

              <CardContent
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "default",
                  p: 3,
                }}
              >
                {/* Icon with Gradient */}
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #ffe0d4, #fff)",
                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
                  }}
                >
                  <step.Icon sx={{ fontSize: 36, color: "orangered" }} />
                </Box>

                {/* Title */}
                <Typography
                  variant="h6"
                  sx={{ flexGrow: 1, fontWeight: "600", ml: 2 }}
                >
                  {step.title}
                </Typography>

                {/* Expand Icon */}
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleExpansion(index);
                  }}
                >
                  <ExpandMoreIcon
                    sx={{
                      transform:
                        expandedStep === index ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.3s",
                    }}
                  />
                </IconButton>
              </CardContent>

              {/* Collapsible Section with framer-motion */}
              <AnimatePresence initial={false}>
                {expandedStep === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    style={{ overflow: "hidden" }}
                  >
                    <CardContent
                      sx={{
                        backgroundColor: "rgba(255, 87, 34, 0.05)",
                        py: 2,
                        px: 3,
                        borderTop: "1px solid rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <Typography variant="body2" color="textSecondary">
                        {step.description}
                      </Typography>
                    </CardContent>
                  </motion.div>
                )}
              </AnimatePresence>
            </Card>
          </motion.div>
        ))}
      </Box>
    </Box>
  );
};

export default WorkProcessMobileView;
